export default function () {
  return {
    name: "Scopolamine Screening",
    description: "Scopolamine description",
    version: "2024061901",
    service_code: "SCOPOLAMINE",
    live: false,
    staged: true,
    questions: [
      {
        title: "You want Scopolamine?",
        code: "scopolamine-1",
        description: "Scopolamine description question 1",
        type: "checkbox",
        choices: [
          {
            label: "Have tried scopolamine before",
          },
          {
            label: "Other",
            children: [
              {
                title: "Please tell us why you want scopolamine...",
                type: "text",
                code: "scopolamine-1-other",
              },
            ],
          },
        ],
      },
    ],
  };
}
